module.exports = __webpack_public_path__ + "static/media/download-mama-graphic.82bd8556.png";